/**
 * 权限的表单验证
 * @author zjs
 * @time 2018-01-05
 */
export default {
    data () {
        return {
            formRules: {
                'name' : [{ required: true, trigger: 'blur' }],
                'remark' : [{ required: true, trigger: 'blur' }]
            }
        }
    }
}